export default {
    asset_tab_advancedFilters_title: "Advanced Filters",
    asset_tab_advancedFilters_clearAll: "Clear All",
    asset_tab_advancedFilters_assetType: "Asset Type",
    asset_tab_advancedFilters_assetSubType: "Asset Subtype",
};